import { createFileRoute } from "@tanstack/react-router";
import { faqs } from "@/components/site/FAQ";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ProblemSolved } from "@/components/site/ProblemSolved";
import { ValueProps } from "@/components/site/ValueProps";
import { ServicesGrid } from "@/components/site/ServicesGrid";
import { Gallery } from "@/components/site/Gallery";
import { FlooringSpotlight } from "@/components/site/FlooringSpotlight";
import { Awards } from "@/components/site/Awards";
import { Concept } from "@/components/site/Concept";
import { Reviews } from "@/components/site/Reviews";
import { FAQ } from "@/components/site/FAQ";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/")({
  component: Index,
  head: () => ({
    meta: [
      { title: "RKD Tile — 30 Years of Custom Tile Craftsmanship in Utah" },
      {
        name: "description",
        content:
          "Custom residential & commercial tile installation in Park City, Salt Lake & Utah County. Call (801) 598-2226.",
      },
      { property: "og:title", content: "RKD Tile — Custom Tile Installation in Utah" },
      { property: "og:url", content: "https://rkdtile.com/" },
      {
        property: "og:description",
        content:
          "30 years of exceptional tile craftsmanship for Utah's most discerning homeowners and builders.",
      },
    ],
    links: [{ rel: "canonical", href: "https://rkdtile.com/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": "https://rkdtile.com/#business",
          name: "RKD Tile",
          description:
            "Custom residential and commercial tile and natural stone installation across Utah since 1996.",
          url: "https://rkdtile.com/",
          telephone: "+1-801-598-2226",
          email: "rkdtile@msn.com",
          foundingDate: "1996",
          priceRange: "$$",
          sameAs: ["https://www.facebook.com/rkdtile"],
          address: {
            "@type": "PostalAddress",
            addressLocality: "West Jordan",
            addressRegion: "UT",
            addressCountry: "US",
          },
          areaServed: [
            "West Jordan, UT",
            "Sandy, UT",
            "Taylorsville, UT",
            "Draper, UT",
            "Park City, UT",
            "Salt Lake City, UT",
          ],
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "5",
            bestRating: "5",
            reviewCount: "8",
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
});

function Index() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <ProblemSolved />
        <ServicesGrid />
        <ValueProps />
        <Gallery />
        <Concept />
        <FlooringSpotlight />
        <Awards />
        <Reviews />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
